/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ForumSchoolCount.vue?vue&type=template&id=9cfc43e0&scoped=true"
import script from "./ForumSchoolCount.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumSchoolCount.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ForumSchoolCount.vue?vue&type=style&index=0&id=9cfc43e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfc43e0",
  null
  
)

export default component.exports